module.exports = __webpack_public_path__ + "img/borrow-crypto-sm.87767d55.svg";